import * as React from "react";
import Grid from '@material-ui/core/Grid';
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Typography } from "components/controls/widget";
import EditacePlatbyFormItem from "./EditacePlatbyFormItem";

export interface PopisPlatby {
    musiPlatit?: boolean;
    neplatit?: boolean;
    jizZaplaceno?: boolean;
    checked?: boolean;
    trida?: number;
    polovicni?: boolean;
    castka?: number;
    hidden?: boolean;
}

export interface Platba {
    sp: PopisPlatby;
    zcp: PopisPlatby;
    soutAm: PopisPlatby;
    soutPro: PopisPlatby;
    por: PopisPlatby;
    fun: PopisPlatby;
    tre: PopisPlatby;
}

interface EditacePlatbyFormProps {
    platba: Platba;
    updatePlatby: (novaPlatba: Platba) => void;
    platbaCelkem: number;
    jenPolovicniPlatby: boolean;
}


class EditacePlatbyForm extends React.PureComponent<EditacePlatbyFormProps & WithStyles<typeof styles>> {

    render() {
        const { platba, updatePlatby, platbaCelkem, jenPolovicniPlatby, classes } = this.props;

        return <Grid container direction="column" justify="space-between">
            {platba.sp.neplatit === true ? null : <EditacePlatbyFormItem title={'Správní poplatek'} pba={platba.sp} updatePby={p => updatePlatby({ ...platba, sp: p })} jeToSp />}
            <EditacePlatbyFormItem title={'Základní členský příspěvek'} jenPolovicniPlatby={jenPolovicniPlatby} pba={platba.zcp} polovicni updatePby={p => updatePlatby({ ...platba, zcp: p })} jeToZcp />
            {platba.soutAm.hidden !== true ? <EditacePlatbyFormItem title={'Soutěžní licence amatérská'} jenPolovicniPlatby={jenPolovicniPlatby} pba={platba.soutAm} polovicni updatePby={p => updatePlatby({ ...platba, soutAm: p })} /> : null}
            {platba.soutPro.hidden !== true ? <EditacePlatbyFormItem title={'Soutěžní licence profi'} jenPolovicniPlatby={jenPolovicniPlatby} pba={platba.soutPro} polovicni updatePby={p => updatePlatby({ ...platba, soutPro: p })} /> : null}
            <EditacePlatbyFormItem title={'Licence  porotce'} pba={platba.por} maxTrida={3} updatePby={p => updatePlatby({ ...platba, por: p })} />
            <EditacePlatbyFormItem title={'Licence  trenéra'} pba={platba.tre} maxTrida={3} updatePby={p => updatePlatby({ ...platba, tre: p })} />
            <EditacePlatbyFormItem title={'Licence  funkcionáře'} pba={platba.fun} maxTrida={2} updatePby={p => updatePlatby({ ...platba, fun: p })} />
            <Grid container direction="row" alignItems="center">
                <Grid item md={3}><Typography variant="h6">{'Celkem k platbě:'}</Typography></Grid>
                <Grid item><Typography variant="h6" className={classes.castka}>{`${platbaCelkem} Kč`}</Typography></Grid>
            </Grid>

        </Grid>;
    }
}

const styles = (theme: Theme) => createStyles({
    castka: {
        padding: 12
    },
});


export default withStyles(styles)(EditacePlatbyForm);


